import axios from 'axios'
import { useState } from 'react'
import { apiStatus } from '../constants/apiStatus'
import { apiUrl, axiosDefaultHeader } from '../constants/apiUrl'
import { loadStatus } from '../constants/loadStatus'
import { errorMsg } from '../constants/messages'
import type { ConversationIllustrationInfo, ConversationInfo } from '../interfaces/ConversationIf'
import type { Result } from '../interfaces/Result'
import { useAuth } from './useAuth'
import { useApiUrl } from './useApiUrl'

interface useC804ConversationRecordSaveProps {
  execConversationRecordSave: (
    convId: string,
    convs: ConversationInfo[],
    illustration_id: ConversationIllustrationInfo[],
  ) => Promise<Result>
  loading: loadStatus
}
// C804 会話記録保存API呼出
export const useC804ConversationRecordSave = (): useC804ConversationRecordSaveProps => {
  const [loading, setLoading] = useState(loadStatus.NONE)
  const auth = useAuth()
  const { buildUrl } = useApiUrl()
  const execConversationRecordSave = async (
    convId: string,
    convs: ConversationInfo[],
    images: ConversationIllustrationInfo[],
  ) => {
    try {
      setLoading(loadStatus.LOADING)
      const jwt = await auth.getJwt()
      if (jwt === '') {
        setLoading(loadStatus.LOADED)
        return { success: false, message: errorMsg.SESSION_ERROR }
      }
      // ヘッダ作成
      const header = Object.assign(axiosDefaultHeader, {
        Authorization: 'Bearer ' + jwt,
      })
      // console.log(header);

      // ボディ作成
      let body = {}
      const conversationList = convs.map(item => {
        return {
          conversation_id: item.conversation_id,
          speaker: item.speaker,
          org_text: item.org_text,
          edit_text: item.text_being_edited,
        }
      })
      const illustratoinIdList = images.map(item => {
        return {
          illustration_id: item.illustration_id,
        }
      })
      body = {
        conv_id: convId,
        conversationList: conversationList,
        illustratoinIdList: illustratoinIdList,
      }
      const response = await axios.put(buildUrl(apiUrl.conversationsLogPath), body, {
        headers: header,
        validateStatus: () => true,
      })
      if (response.status === apiStatus.SUCCESS) {
        setLoading(loadStatus.LOADED)
        return { success: true, info: response.data }
      }
      setLoading(loadStatus.LOADED)
      if (response.data && response.data.message) {
        return { success: false, message: response.data.message }
      }
      return { success: false, message: errorMsg.SYSTEM_ERROR }
    } catch (error) {
      setLoading(loadStatus.LOADED)
      return { success: false, message: errorMsg.SYSTEM_ERROR }
    }
  }

  return { execConversationRecordSave, loading }
}
